import Timeline from './Timeline';
export default Timeline;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/timeline/index.js
// module id = 1646
// module chunks = 0